import moreArrowIcon from '../../../../../assests/classroomApplets/moreArrow.svg';
import classes from './CarouselMoreButton.module.css';

const CarouselMoreButton = ({ count, hiddenNames = [], onClick }) => {

  return (
    count > 0 ?
      <div className={classes.Wrap}>
        {hiddenNames.length > 0 ?
          <div className={classes.TooltipFrame} role="tooltip">
            <span className={classes.TooltipArrow} />
            <div className={classes.Tooltip}>
              {hiddenNames.map((name, index) =>
                <span key={`${name}-${index}`} className={classes.TooltipName}>{name}</span>
              )}
            </div>
          </div>
          : null}
        <button type="button" className={classes.Button} onClick={onClick}>
          <span className={classes.Count}>+{count}</span>
          <img src={moreArrowIcon} className={classes.Chevron} />
        </button>
      </div>
      : null
  );
};

export default CarouselMoreButton;